import  { useEffect, useRef } from "react";

export interface PieData {
  title: string;
  color: string;
  value: string;
  lastValue: string;
}

const CanvasComponent = ({
  lastValue,
  value,
  color,
}: {
  lastValue: number;
  value: number;
  color: string[];
}) => {
  useEffect(() => {
    updateCanvas();
  });

  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const updateCanvas = () => {
    const apart = (value - lastValue) / 10;
    let i = 1;

    const canvas = canvasRef.current;
    const ctx = canvas?.getContext("2d");
    const origin = 1.5 * Math.PI;
    const lineWidth = 20;
    const pieSize = 66;
    const pieSettings = [pieSize, pieSize, pieSize - lineWidth / 2] as const;
    if (ctx) ctx.lineWidth = lineWidth;

    const update = setInterval(() => {
      const nextValue = (lastValue + apart * i) / 50 + 1.5;
      const newValue = nextValue * +Math.PI.toFixed(2);

      if (ctx && canvas) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.strokeStyle = color[1];
        ctx.beginPath();
        ctx.arc(...pieSettings, newValue, origin);
        ctx.stroke();

        ctx.strokeStyle = color[0];
        ctx.beginPath();
        ctx.arc(...pieSettings, origin, newValue);
        ctx.stroke();
      }

      if (i >= 10) {
        clearInterval(update);
      } else {
        i++;
      }
    }, 20);
  };
  return <canvas ref={canvasRef} width={132} height={132} />;
};

const PieChart = ({ data }: { data: PieData[] }) => (
  <div className="flex flex-col items-center justify-between gap-y-2 sm:flex-row">
    {/* pie chart */}
    <div className="scale-75 sm:scale-100">
      <CanvasComponent
        lastValue={parseInt(data[0].lastValue)}
        value={parseInt(data[0].value)}
        color={[data[0].color, data[1].color]}
      />
    </div>
    {/* text data section */}
    <div className="grow sm:pl-16" aria-label="asset allocation">
      {data.map((item, index) => (
        <div
          key={`pieItem${index}`}
          className="flex items-center justify-between pb-3 text-sm sm:text-lg"
        >
          <div className="flex items-center gap-x-3">
            <div
              className="h-3 w-3 rounded-full sm:h-6 sm:w-6"
              style={{
                backgroundColor: item.color,
              }}
            />
            <p>{item.title}</p>
          </div>
          <p>{`${item.value}%`}</p>
        </div>
      ))}
    </div>
  </div>
);

export default PieChart;
